export default {
    
    findOccurrenceTypes:            { method: 'get',    url: 'occurrence_types' },
    findOccurrenceTypesTeacher:     { method: 'get',    url: 'occurrence_types/teacher' },
    createOccurrenceType:           { method: 'post',   url: 'occurrence_types'},
    updateOccurrenceType:           { method: 'put',    url: 'occurrence_types/{id}'},
    deleteOccurrenceType:           { method: 'delete', url: 'occurrence_types/{id}'},
    findStatusOccurrenceType:       { method: 'get',    url: 'occurrence_types/status' },
    findNaturesOccurrenceType:      { method: 'get',    url: 'occurrence_types/natures' },
}